var m = require('mithril');
var key = require('../../libs/keybindings');
var Model = require('../../libs/Model');
var modal = require('../../layout/components/modal');
var write = require('../models/write');
var Point = require('../models/point');
var loaders = require('../../layout/components/loaders');
var rowActionDropdown = require('../../components/rowActionDropdown');
var writeCommandEvents = require('../writeCommandEvents');
var writeOperations = require('../writeOperation');

var component = {};
var DEFAULT_MULTI_POINT_WRITE_TITLE = 'Set Multi-Point Write Values';
var dialogueGeneration = 0;
var saveActionGeneration = 0;

component.errors = [];
component.successes = [];

function normalizeRid(rid) {
  if (rid && typeof rid === 'object') {
    rid = rid['@rid'];
  }
  if (typeof rid !== 'string' || !rid) {
    return null;
  }
  return rid[0] === '#' ? rid.slice(1) : rid;
}

function writeGroupTitle(dataset) {
  var title = dataset && dataset.writeGroupTitle;
  if (typeof title === 'string' && title.trim()) {
    return title.trim();
  }
  return DEFAULT_MULTI_POINT_WRITE_TITLE;
}

function routeRid(rid) {
  var normalizedRid = normalizeRid(rid);
  return normalizedRid ? normalizedRid : null;
}

function sameRid(left, right) {
  return routeRid(left) === routeRid(right);
}

function pointDetailHref(pointRid, columnRid) {
  var normalizedPointRid = routeRid(pointRid);
  if (!normalizedPointRid) return '#';

  var href = '/#!/point/' + normalizedPointRid;
  var normalizedColumnRid = routeRid(columnRid);
  if (normalizedColumnRid) {
    href += '?column=' + encodeURIComponent('#' + normalizedColumnRid);
  }
  return href;
}

function displayName(record) {
  if (!record) return '';
  if (record.name === 'root') return 'Home';
  if (record['@class'] === 'Room' && record.roomNumber) {
    return [record.name, record.roomNumber].filter(Boolean).join(' ');
  }
  return record.name || record.label || record['@class'] || record['@rid'] || '';
}

function formatPath(records) {
  return (Array.isArray(records) ? records : [])
    .map(displayName)
    .filter(function (part) { return !!part; })
    .join(' / ');
}

function datasetPath(dataset) {
  var path = Array.isArray(dataset && dataset.path) ? dataset.path.slice() : [];
  if (dataset && dataset['@rid'] && !path.some(function (record) {
    return sameRid(record && record['@rid'], dataset['@rid']);
  })) {
    path.push({
      '@class': dataset['@class'] || 'Dataset',
      '@rid': dataset['@rid'],
      name: dataset.name
    });
  }
  return path;
}

function columnForWriteGroupEdge(dataset, writeGroupEdge) {
  var pointRid = writeGroupEdge && writeGroupEdge.in && writeGroupEdge.in['@rid'];
  if (!pointRid || !Array.isArray(dataset && dataset.out_Column)) return null;
  return dataset.out_Column.find(function (columnEdge) {
    return columnEdge && columnEdge.in && sameRid(columnEdge.in['@rid'], pointRid);
  }) || null;
}

function writeGroupEdgeLabel(dataset, writeGroupEdge) {
  var columnEdge = columnForWriteGroupEdge(dataset, writeGroupEdge);
  var pointRecord = writeGroupEdge && writeGroupEdge.in;
  var finalName = (columnEdge && columnEdge.name) ||
    (writeGroupEdge && writeGroupEdge.name) ||
    (pointRecord && pointRecord.name) ||
    (pointRecord && pointRecord['@rid']) ||
    'Point';

  return formatPath(datasetPath(dataset).concat([{
    '@class': 'Column',
    '@rid': columnEdge && columnEdge['@rid'],
    name: finalName
  }]));
}

function pointDisplayName(dataset, writeGroupEdge, index) {
  var columnEdge = columnForWriteGroupEdge(dataset, writeGroupEdge);
  var pointRecord = writeGroupEdge && writeGroupEdge.in;
  return (columnEdge && columnEdge.name) ||
    (writeGroupEdge && writeGroupEdge.name) ||
    (pointRecord && pointRecord.name) ||
    ('Point ' + (index + 1));
}

function buildPointLinkItems(dataset) {
  return ((dataset && dataset.out_WriteGroup) || []).map(function (writeGroupEdge) {
    var pointRecord = writeGroupEdge && writeGroupEdge.in;
    var pointRid = pointRecord && pointRecord['@rid'];
    if (!pointRid) return null;

    var columnEdge = columnForWriteGroupEdge(dataset, writeGroupEdge);
    return {
      href: pointDetailHref(pointRid, columnEdge && columnEdge['@rid']),
      label: writeGroupEdgeLabel(dataset, writeGroupEdge),
      onclick: function () {
        modal.vm.close();
      }
    };
  }).filter(Boolean);
}

function saveError(message) {
  component.errors = [message];
  m.redraw();
  return false;
}

component.editDialogue = function (record, parentRid) {
  var generation = ++dialogueGeneration;
  var writeGroupRid = normalizeRid(record && record.in && record.in.writeGroup);

  component.dialogueGeneration = generation;
  component.parentLocationRid = normalizeRid(parentRid);
  component.sourcePointRid = normalizeRid(record && record.in && record.in['@rid']);
  component.sourcePointRecord = null;
  component.dataset = null;
  component.form = null;
  component.array = null;
  component.errors = [];
  component.successes = [];
  component.writeOperations = {};

  var submit = function () {
    return component.save()
  };

  key.setScope('modal');
  key('enter', 'modal', submit);

  modal.vm.title(DEFAULT_MULTI_POINT_WRITE_TITLE)
  modal.vm.body = component.view,
  modal.vm.buttons([
    {
      label: "Submit",
      class: "btn-good",
      func: submit
    }
  ]);
  modal.vm.open({ suppressPointUpdates: [record && record.in && record.in['@rid']] });

  if (!writeGroupRid) {
    return Promise.resolve(saveError('Cannot load multi-point write data without a write group.'));
  }

  return loaders.requestWithLoader({
    loader: 'background',
    url: '/api/v1/dataset/' + writeGroupRid,
    method: 'GET'
  })
  .then(function (dataset) {
    if (generation !== dialogueGeneration) {
      return;
    }

    component.dataset = dataset;
    if (modal.vm.body === component.view &&
        typeof modal.vm.setSuppressedPointUpdates === 'function') {
      modal.vm.setSuppressedPointUpdates((dataset.out_WriteGroup || []).map(function (edge) {
        return edge && edge.in && edge.in['@rid'];
      }).concat([component.sourcePointRid]));
    }
    modal.vm.title(writeGroupTitle(dataset));
    component.sourcePointRecord = (dataset.out_WriteGroup || [])
      .map(function (edge) { return edge && edge.in; })
      .find(function (pointRecord) {
        return sameRid(pointRecord && pointRecord['@rid'], component.sourcePointRid);
      }) || null;
    if (component.sourcePointRecord) return component.sourcePointRecord;
    return loaders.requestWithLoader({
      loader: 'background',
      url: '/api/v1/point/' + component.sourcePointRid,
      method: 'GET'
    }).then(function (sourcePointRecord) {
      component.sourcePointRecord = sourcePointRecord;
      return sourcePointRecord;
    });
  })
  .then(function () {
    if (generation !== dialogueGeneration || !component.dataset) return;
    component.form = component.dataset.out_WriteGroup.map(function (el) {
      return el.in.value;
    });
    component.array = JSON.parse(JSON.stringify(component.form));
    m.redraw();
  });
}

component.save = function () {
  var saveGeneration = ++saveActionGeneration;
  var saveDialogueGeneration = dialogueGeneration;
  function isCurrentSave() {
    return saveGeneration === saveActionGeneration &&
      saveDialogueGeneration === dialogueGeneration;
  }
  function ensureCurrentSave() {
    if (isCurrentSave()) return;
    var error = new Error('A newer multi-point write replaced this save.');
    error.code = 'MULTI_POINT_WRITE_SAVE_SUPERSEDED';
    throw error;
  }
  if (!component.parentLocationRid) {
    return saveError('Cannot write multi-point values without a parent location or equipment context.');
  }
  if (!component.dataset || !Array.isArray(component.dataset.out_WriteGroup)) {
    return saveError('Multi-point write data is still loading. Try again in a moment.');
  }
  if (!Array.isArray(component.form)) {
    return saveError('Multi-point write data is still loading. Try again in a moment.');
  }
  if (!component.sourcePointRid) {
    return saveError('Cannot write multi-point values without a source point.');
  }
  var dataset = component.dataset;
  var form = component.form.slice();
  var parentLocationRid = component.parentLocationRid;
  var sourcePointRid = component.sourcePointRid;
  var pointMissingWriteConfiguration = dataset.out_WriteGroup.find(function (el) {
    return !Point.writeConfigFingerprint(el && el.in);
  });
  if (pointMissingWriteConfiguration || !Point.writeConfigFingerprint(component.sourcePointRecord)) {
    var unavailableName = pointMissingWriteConfiguration
      ? pointDisplayName(dataset, pointMissingWriteConfiguration,
        dataset.out_WriteGroup.indexOf(pointMissingWriteConfiguration))
      : 'the logical source Point';
    return saveError('Point write configuration is unavailable for ' +
      unavailableName + '. Reload and try again.');
  }
  var stagedValues = dataset.out_WriteGroup.map(function (el, idx) {
    return {
      pointRid: el.in['@rid'],
      value: form[idx]
    };
  });
  var expectedPointConfiguration = Point.expectedPointConfiguration(
    [component.sourcePointRecord].concat(dataset.out_WriteGroup.map(function (el) { return el.in; }))
  );
  component.errors = [];
  component.successes = [];
  var url = '/api/v1/point/' + dataset.out_WriteGroup[0].in['@rid'].slice(1) +
    '/write/' + parentLocationRid;
  component.writeOperations = component.writeOperations || {};
  var writeOperation = null;
  return writeOperations.prepare(
    component.writeOperations,
    'group',
    url,
    {
      value: form[0],
      commandType: 'write',
      sourcePointRid: '#' + sourcePointRid,
      expectedPointConfiguration: expectedPointConfiguration,
      stagedValues: stagedValues
    },
    {
      scope: ['#' + sourcePointRid, parentLocationRid, 'multi-point-write'].join(':'),
      intent: {
        commandType: 'write',
        sourcePointRid: '#' + sourcePointRid,
        values: form
      },
      conflictScopes: ['#' + sourcePointRid]
        .concat(stagedValues.map(function (entry) { return entry.pointRid; }))
        .filter(function (rid, index, all) { return all.indexOf(rid) === index; })
        .map(function (rid) {
          return writeOperations.pointConflictScope(rid, parentLocationRid);
        }),
      conflictGroup: JSON.stringify({
        surface: 'multi-point-write',
        sourcePointRid: '#' + sourcePointRid,
        parentRid: parentLocationRid,
        values: form
      }),
      recoveryPolicy: writeOperations.ATTENDED_RECOVERY_POLICY
    }
  )
  .then(function (preparedOperation) {
    writeOperation = preparedOperation;
    if (!isCurrentSave()) return { superseded: true };
    return writeCommandEvents.waitForPointWrite({
    pointRids: writeOperations.pointRidsForOperation(writeOperation),
    request: async function () {
      ensureCurrentSave();
      await writeOperations.markAttempted(writeOperation);
      ensureCurrentSave();
      return loaders.requestWithLoader({
        loader: 'submit',
        method: 'PUT',
        url: writeOperation.url,
        body: writeOperation.body
      });
    },
    timeoutMessage: 'Timed out waiting for multi-point write confirmation.'
    });
  })
    .then(async function (completion) {
      if (completion && completion.superseded || !isCurrentSave()) {
        return { superseded: true };
      }
      await writeOperations.complete(component.writeOperations, 'group', writeOperation);
      if (!isCurrentSave()) return { superseded: true };
      loaders.submit.stop();

      var command = completion && completion.command;
      if (Array.isArray(command)) {
        command = command[0];
      }
      command = command || {};
      var commandUser = command.user || {};
      var commandUserName = [commandUser.firstName, commandUser.lastName]
        .filter(Boolean).join(' ') || 'unknown user';
      component.successes = [];
      component.successes.push('Successfully updated by ' + commandUserName + ' on ' + new Date());
      m.redraw();
      return completion;
    })
    .catch(async function (error) {
      if (!isCurrentSave() || error && error.code === 'MULTI_POINT_WRITE_SAVE_SUPERSEDED') {
        return false;
      }
      if (error && error.writeApplied) {
        loaders.submit.stop();
        component.errors = [];
        component.successes = [
          'This exact multi-point write was already confirmed; no duplicate request was sent.'
        ];
        m.redraw();
        return { writeApplied: true };
      }
      if (writeOperation) {
        try {
          await writeOperations.fail(component.writeOperations, 'group', writeOperation, error);
        } catch (recoveryError) {
          error = recoveryError;
        }
      }
      if (!isCurrentSave()) return false;
      loaders.submit.stop();

      component.errors = [];
      component.errors.push('Failed update on ' + new Date() + ' with error: ' + ((error && (error.error || error.message)) || error));
      m.redraw();
      throw error;
    });
}

component.view = function () {
  if (!Array.isArray(component.form)) {
    return m('div', 'Loading multi-point write...');
  }
  var pointLinkItems = buildPointLinkItems(component.dataset);

  return m('div', [
    Model.errorView.call(component),
    Model.successView.call(component),
    m('div.page-header.flex.justify-end.items-end.mb2', [
      pointLinkItems.length
        ? m('div.multi-point-write-point-links', [
          m(rowActionDropdown, {
            align: 'right',
            items: pointLinkItems,
            buttonClass: 'dib point-detail-modal-link',
            buttonStyle: {
              minWidth: '2.1rem',
              paddingTop: '0.05rem',
              paddingBottom: '0.12rem',
              paddingLeft: '0.3rem',
              paddingRight: '0.3rem',
              lineHeight: '1'
            },
            label: m('i.icon.ion-ios-gear.blue', {
              style: {
                'font-size': '1.5rem'
              }
            })
          })
        ])
        : null
    ]),
    m('table.w-100.f3.fw2.pt2.pb3', [
      m('thead', [
        m('tr', [
          m('th.w-33', 'Point'),
          m('th.w-33', 'Current Value'),
          m('th.w-33', 'New Value')
        ])
      ]),
      m('tbody', component.form.map(function (el, idx) {
        var writeGroupEdge = component.dataset.out_WriteGroup[idx];
        return m('tr', [
          m('td.tc.f-headline.pl4', {style:{backgroundColor: '#333'}}, m('p.mr4', pointDisplayName(component.dataset, writeGroupEdge, idx))),
          m('td.tc.f-headline', {style:{backgroundColor: '#333'}}, m('p', component.array[idx])),
          m('td.tl.f-headline', {style:{backgroundColor: '#333'}}, [
            m('input.h4.w-50.tl', {
              type: 'number',
              onchange: function (e) {
                  component.form[idx] = e.target["value"];
              },
              value: component.form[idx]
            })
          ])
        ])
      }))
    ])
  ]);
};

module.exports = component;
